/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * LSQ Management API
 * LeadSquared event ingestion via LSQ Management (send-event-to-lsq).
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type { SendEventToLsq200, SendEventToLsqRequest } from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Submits lead details and an activity payload to LeadSquared through the LSQ Management gateway. Auth and tenant headers are typically set by the app HTTP client; they are listed here when callers must pass them explicitly.
 * @summary Send event to LSQ
 */
export const sendEventToLsq = (
  sendEventToLsqRequest: SendEventToLsqRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SendEventToLsq200>(
    {
      url: `/send-event-to-lsq`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sendEventToLsqRequest,
      signal,
    },
    options,
  );
};

export const getSendEventToLsqMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendEventToLsq>>,
    TError,
    { data: SendEventToLsqRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendEventToLsq>>,
  TError,
  { data: SendEventToLsqRequest },
  TContext
> => {
  const mutationKey = ["sendEventToLsq"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendEventToLsq>>,
    { data: SendEventToLsqRequest }
  > = (props) => {
    const { data } = props ?? {};

    return sendEventToLsq(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendEventToLsqMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendEventToLsq>>
>;
export type SendEventToLsqMutationBody = SendEventToLsqRequest;
export type SendEventToLsqMutationError = void;

/**
 * @summary Send event to LSQ
 */
export const useSendEventToLsq = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendEventToLsq>>,
      TError,
      { data: SendEventToLsqRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendEventToLsq>>,
  TError,
  { data: SendEventToLsqRequest },
  TContext
> => {
  const mutationOptions = getSendEventToLsqMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
